import styled from 'styled-components'
import { progressiveBreakpoints } from '../../constants/theme'

const HeadingSecondary = styled.h2`
  margin-bottom: 1rem;
`

const ContentContainer = styled.div`
  overflow: hidden;

  @media ${progressiveBreakpoints.desktop} {
    max-width: 90%;
  }
`

const Text = styled.p`
  font-size: 1rem;
  line-height: 1.25;

  @media ${progressiveBreakpoints.desktopSmall} {
    font-size: 1.125rem;
    line-height: 1.44;
  }
`

export { HeadingSecondary, ContentContainer, Text }
